import { RydBookmark } from "../model/bookmark";
import { AbstractHorizontalContainer } from "../model/containers";
import { ComputedContextFrame, ContextPlane } from "../model/context";
import { RydProject } from "../model/project";
import { StateClassWrapper } from "../stores/WorkspaceStore";


export function sanitizeProjectLengthIfNeeded(
    project: RydProject,
    bookmark: RydBookmark,
    setterCallbacks: {
        setWorkspaceContextPlane: (cp: StateClassWrapper<ContextPlane>) => void,
        setWorkspaceLines: (lines: AbstractHorizontalContainer<any>[]) => void,
        // setWorkspaceComputedContextFrame: (frame: ComputedContextFrame) => void,
    }
) {
    const projectLength = project.getLength();
    if (bookmark.position > projectLength) {

        const l = bookmark.position + 64;

        // extend project length to accommodate bookmark
        console.log('updating project length to accommodate bookmark at', bookmark.position);
        project.getAll().forEach(line => {
            line.setLength(l); // add some padding
        });
        project.setLength(l);

        // extend rows in context frame
        project.contextFrame.grid.getRows().forEach(row => {
            row.rowLength = l;
        });

        // invoke setters to update workspace state
        setterCallbacks.setWorkspaceContextPlane({ stateObject: project.contextFrame.grid });
        setterCallbacks.setWorkspaceLines([...project.getAll()]);
        // setterCallbacks.setWorkspaceComputedContextFrame(project.contextFrame.grid.);

    }
}